import { __rest, __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { theme } from '@citygross/design-tokens';
import { BaseIconButton, Loading, LoadingContainer, LoadingSpinner, ButtonBadge } from './Button.styles.js';

var IconButton = function IconButton(_a) {
  var ariaLabel = _a.ariaLabel,
      badgeBackground = _a.badgeBackground,
      border = _a.border,
      buttonBadge = _a.buttonBadge,
      _b = _a.color,
      color = _b === void 0 ? 'darkest' : _b,
      height = _a.height,
      width = _a.width,
      icon = _a.icon,
      isDisabled = _a.isDisabled,
      loading = _a.loading,
      noWrap = _a.noWrap,
      _onClick = _a.onClick,
      opacity = _a.opacity,
      shadow = _a.shadow,
      tabIndex = _a.tabIndex,
      props = __rest(_a, ["ariaLabel", "badgeBackground", "border", "buttonBadge", "color", "height", "width", "icon", "isDisabled", "loading", "noWrap", "onClick", "opacity", "shadow", "tabIndex"]);

  return React.createElement(BaseIconButton, __assign({
    "aria-label": ariaLabel,
    border: border,
    color: theme && theme.palette ? theme === null || theme === void 0 ? void 0 : theme.palette[color] : '#333333',
    disabled: loading || isDisabled,
    height: height,
    width: width,
    icon: icon,
    isDisabled: loading || isDisabled,
    loading: loading || null,
    noWrap: noWrap,
    onClick: function onClick(e) {
      return _onClick && _onClick(e);
    },
    opacity: opacity,
    shadow: shadow,
    tabIndex: tabIndex
  }, props), loading && React.createElement(Loading, null, React.createElement(LoadingContainer, null, React.createElement(LoadingSpinner, null))), icon, buttonBadge ? React.createElement(ButtonBadge, {
    background: badgeBackground,
    smallBadge: true
  }, buttonBadge) : null, React.createElement("span", {
    className: "ripple"
  }));
};

export { IconButton };